<!-- Barra de progreso global para transiciones de ruta. Reacciona a eventos del
     Router; clave en IIS prod donde los chunks lazy tardan en bajar la primera
     vez y sin esto el sidebar/menu "parecia colgado". -->
<app-route-progress-bar></app-route-progress-bar>

<router-outlet></router-outlet>

<!-- Stack de notificaciones de chat — siempre montado para que cualquier
     mensaje entrante muestre toast sin importar la ruta actual. -->
<app-chat-notification-overlay></app-chat-notification-overlay>

<!-- Modal "tu sesión está por expirar" con countdown + botón Continuar (refresh
     token) o Cerrar sesión. Vive a nivel raíz para aparecer encima de cualquier
     ruta. Se controla por `AuthService.expiryModal` signal. -->
<app-expiry-modal></app-expiry-modal>

<!-- Command Palette global ⌘K / Ctrl+K. Overlay flotante con jump-to-anything
     sobre el menu, recientes y acciones rapidas. Vive en el root para que su
     z-index quede por encima del sidebar/header sin pelear con stacking
     contexts. El listener de teclado esta en CommandPaletteService.constructor. -->
<app-command-palette></app-command-palette>

<!-- Quick-view popover global — usado por la directiva appQuickView para
     mostrar previews en hover (desktop) / long-press (mobile). El service tiene
     un signal de estado; cuando un caller abre, este componente renderiza el
     template + data del signal. -->
<app-quick-view-popover></app-quick-view-popover>
